import { createContext, useEffect, useState } from "react";
import type { IActiveConvenio, IActiveConvenioProvider, IContext } from "./types";
import {
  getActiveConvenioStorage,
  getLastConvenioSelected,
  setActiveConvenioStorage,
} from "./utils";
import { useAuth } from "@features/auth";
import { ROLE_CONVENIO } from "../../types/role";

export const ActiveConvenioContext = createContext<IContext>({} as IContext);

export const ActiveConvenioProvider = ({ children }: IActiveConvenioProvider) => {
  const auth = useAuth();
  const [activeConvenio, setActiveConvenio] = useState<IActiveConvenio | undefined>();

  useEffect(() => {
    if (auth.user?.role_id !== ROLE_CONVENIO) return;

    const fromStorage = getActiveConvenioStorage();
    if (fromStorage) {
      setActiveConvenio(fromStorage);
      return;
    }

    getLastConvenioSelected()
      .then((convenio) => {
        if (convenio) setActiveConvenio(convenio);
      })
      .catch((err) => console.error("[ActiveConvenio] fetch error:", err));
  }, [auth.user?.role_id]);

  useEffect(() => {
    setActiveConvenioStorage(activeConvenio);
  }, [activeConvenio]);

  return (
    <ActiveConvenioContext.Provider value={{ ...activeConvenio }}>
      {children}
    </ActiveConvenioContext.Provider>
  );
};
